import React, { Component } from "react";
import { Row, Column } from "react-foundation";

import "css/SummaryItem.css";

import ColourChip from "./ColourChip";
import DateDisplay from "./Date";
import removeIcon from "images/remove.svg";
import Loading from "./Loading";
import SummaryImage from "./SummaryImage";
import DimensionSummary from "./DimensionSummary";
import Image from "components/Image";

const DoorCompositeSummaryItem = ({ Product }) => {
    return (
        <Row>
            <Column medium={3} className="centerImageOnSmall">
                {Product.FlattenedImageSrc && (
                    <img className="preview" src={Product.FlattenedImageSrc} alt="Preview" />
                )}
                {!Product.FlattenedImageSrc && <Loading text="Generating..." />}
            </Column>
            <Column medium={4}>
                <Row>
                    <Column small={12} className="item-type">
                        {Product.ItemType.Name}
                    </Column>
                </Row>
                <Row isColumn>
                    <table className="product-overview">
                        <tbody>
                            <tr>
                                <td className="product-label">Type</td>
                                <td className="product-field">{Product.Type.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Handle</td>
                                <td className="product-field">{Product.Handle.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Lock</td>
                                <td className="product-field">Winkhaus Secure</td>
                            </tr>
                            <tr>
                                <td className="product-label">Letterbox</td>
                                <td className="product-field">
                                    {Product.HasLetterbox ? Product.Letterbox.Name : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Knocker</td>
                                <td className="product-field">
                                    {Product.HasKnocker ? Product.Knocker.Name : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Frame</td>
                                <td className="product-field">{Product.Frame.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Style</td>
                                <td className="product-field">{Product.Glass.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Energy Rating</td>
                                <td className="product-field">{Product.Efficiency.Name}</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
            </Column>
            <Column medium={5}>
                <Row>
                    <Column small={4} className="chip-label">
                        <span>Exterior</span>
                    </Column>
                    <Column small={4} className="chip-label">
                        <span>Interior</span>
                    </Column>
                    <Column small={4} className="chip-label">
                        <span>Handle</span>
                    </Column>
                </Row>
                <Row>
                    <Column small={4} className="chip-container">
                        <ColourChip
                            src={Product.Colour.Exterior.ImageSrc}
                            text={Product.Colour.Exterior.Name}
                        />
                    </Column>
                    <Column small={4} className="chip-container">
                        <ColourChip
                            src={Product.Colour.Interior.ImageSrc}
                            text={Product.Colour.Interior.Name}
                        />
                    </Column>
                    <Column small={4} className="chip-container">
                        <ColourChip src={Product.Handle.ImageSrc} text={Product.Handle.Name} />
                    </Column>
                </Row>
            </Column>
        </Row>
    );
};
const DoorUPVCSummaryItem = ({ Product }) => {
    const isPatioOrBifold = /patio/i.test(Product.Type.Name) || /bi-?fold/i.test(Product.Type.Name);   
    const unit = Product.Size.Unit;
    return (
        <Row>
            <Column medium={3} className="centerImageOnSmall">
                <SummaryImage Product={Product} />
            </Column>
            <Column medium={4}>
                <Row>
                    <Column small={12} className="item-type">
                        {Product.ItemType.Name}
                    </Column>
                </Row>
                <Row isColumn>
                    <table className="product-overview">
                        <tbody>
                            <tr>
                                <td className="product-label">Style</td>
                                <td className="product-field">{Product.Type.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Handle</td>
                                <td className="product-field">
                                    {Product.Handle.Type} ({Product.Handle.Name})
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Lock</td>
                                <td className="product-field">{Product.Lock.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Letterbox</td>
                                <td className="product-field">
                                    {Product.HasLetterbox ? Product.Letterbox.Name : "-"}
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Energy Rating</td>
                                <td className="product-field">{Product.Efficiency.Name}</td>
                            </tr>
                            {isPatioOrBifold &&
                            <tr>
                                <td className="product-label">Dimensions</td>
                                <td className="product-field">
                                    <DimensionSummary width={Product.Size.Width} height={Product.Size.Height} unit={unit}/>
                                </td>
                            </tr>
                            }
                        </tbody>
                    </table>
                </Row>
            </Column>
            <Column medium={5}>
                <Row>
                    <Column small={4} className="chip-label">
                        <span>Exterior</span>
                    </Column>
                    <Column small={4} className="chip-label">
                        <span>Interior</span>
                    </Column>
                    <Column small={4} className="chip-label" isLast>
                        <span>Handle</span>
                    </Column>
                </Row>
                <Row>
                    <Column small={4} className="chip-container">
                        <ColourChip src={Product.Colour.ImageSrc} text={Product.Colour.Name} />
                    </Column>
                    <Column small={4} className="chip-container">
                        <ColourChip
                            src={Product.Colour.WhiteInterior ? "White" : Product.Colour.ImageSrc}
                            text={Product.Colour.WhiteInterior ? "White" : Product.Colour.Name}
                        />
                    </Column>
                    <Column small={4} className="chip-container" isLast>
                        <ColourChip src={Product.Handle.ImageSrc} text={Product.Handle.Name} />
                    </Column>
                </Row>
            </Column>
        </Row>
    );
};
const WindowSummaryItem = ({ Product }) => {
    return (
        <Row>
            <Column medium={3} className="centerImageOnSmall">
                <SummaryImage Product={Product} />
            </Column>
            <Column medium={4}>
                <Row>
                    <Column small={12} className="item-type">
                        {Product.ItemType.Name}
                    </Column>
                </Row>
                <Row isColumn>
                    <table className="product-overview">
                        <tbody>
                            <tr>
                                <td className="product-label">Style</td>
                                <td className="product-field">{Product.Style.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Size</td>
                                <td className="product-field capitalised">
                                    {
                                        Product.Size.Display.Width && Product.Size.Display.Height && Product.Size.Display.Unit ? 
                                            <DimensionSummary width={Product.Size.Display.Width} height={Product.Size.Display.Height} unit={Product.Size.Display.Unit}/>
                                            :
                                            Product.Size.Display
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Layout</td>
                                <td className="product-field">{Product.Design.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Lock</td>
                                <td className="product-field">{Product.Lock.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Energy Rating</td>
                                <td className="product-field">{Product.Efficiency.Name}</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
            </Column>
            <Column medium={5} >
                <Row>
                    <Column small={4} className="chip-label">
                        <span>Exterior</span>
                    </Column>
                    <Column small={4} className="chip-label" isLast>
                        <span>Interior</span>
                    </Column>

                    {Product.HasHandle && (
                        <Column small={4} className="chip-label" isLast>
                            <span>Handle</span>
                        </Column>
                    )}
                </Row>
                <Row>
                    <Column small={4} className="chip-container">
                        <ColourChip src={Product.Colour.ImageSrc} text={Product.Colour.Name} />
                    </Column>
                    <Column small={4} className="chip-container" isLast>
                        <ColourChip
                            src={Product.Colour.WhiteInterior ? "White" : Product.Colour.ImageSrc}
                            text={Product.Colour.WhiteInterior ? "White" : Product.Colour.Name}
                        />
                    </Column>
                    {Product.HasHandle && (
                        <Column small={4} className="chip-container" isLast>
                            <ColourChip src={Product.Handle.ImageSrc} text={Product.Handle.Name} />
                        </Column>
                    )}
                </Row>
            </Column>
        </Row>
    );
};
const ConservatorySummaryItem = ({ Product }) => {
    return (
        <Row>
            <Column medium={3} className="centerImageOnSmall">
                <Image src={Product.FlattenedImageSrc} alt=""/>
            </Column>
            <Column medium={4}>
                <Row>
                    <Column small={12} className="item-type">
                        {Product.ItemType.Name}
                    </Column>
                </Row>
                <Row isColumn>
                    <table className="product-overview">
                        <tbody>
                            <tr>
                                <td className="product-label">Style</td>
                                <td className="product-field">{Product.Style.Name}</td>
                            </tr>
                            <tr>
                                <td className="product-label">Size</td>
                                <td className="product-field">
                                    <DimensionSummary width={Product.Size.UserSelected.Width} height={Product.Size.UserSelected.Height} unit={Product.Size.UserSelected.Unit} isConservatory/>
                                </td>
                            </tr>
                            <tr>
                                <td className="product-label">Roof</td>
                                <td className="product-field">{Product.Design.Name}</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
            </Column>
            <Column medium={5} >
                <Row>
                    <Column small={4} className="chip-label">
                        <span>Exterior</span>
                    </Column>
                    <Column small={4} className="chip-label" isLast>
                        <span>Interior</span>
                    </Column>
                </Row>
                <Row>
                    <Column small={4} className="chip-container">
                        <ColourChip src={Product.Colour.ImageSrc} text={Product.Colour.Name} />
                    </Column>
                    <Column small={4} className="chip-container" isLast>
                        <ColourChip
                            src={Product.Colour.WhiteInterior ? "White" : Product.Colour.ImageSrc}
                            text={Product.Colour.WhiteInterior ? "White" : Product.Colour.Name}
                        />
                    </Column>
                </Row>
            </Column>
        </Row>
    );
};
const AdditionalSummaryItem = ({Product}) => {
    return (
        <Row>
            <Column medium={3} className="centerImageOnSmall">
                <Image src={Product.FlattenedImageSrc} alt=""/>
            </Column>
            <Column medium={4}>
                <Row>
                    <Column small={12} className="item-type">
                        Additional Product
                    </Column>
                </Row>
            </Column>
            <Column medium={5}> </Column>
        </Row>
    );
}
class SummaryItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            openedOnSmall: false
        };
    }

    componentWillMount() {
        if (this.props.openOnLoad) {
            this.setState({ openedOnSmall: true });
        }
    }

    render() {
        let { Product, onDelete, onChange } = this.props;

        let isWindow = Product.ItemType.Name === "Window";
        let isDoor = Product.ItemType.Name === "Door";
        let isConservatory = Product.ItemType.Name === "Conservatory";
        let isAdditional = Product.ItemType.Name === "Additional";
        let isUPVC = (Product.Type && Product.Type.IsComposite === false) || false;
        let isComposite = (Product.Type && Product.Type.IsComposite === true) || false;

        return (
            <div className="SummaryItem">
                <Row
                    isColumn
                    onClick={() => this.setState({ openedOnSmall: !this.state.openedOnSmall })}
                    className="product-header"
                >
                    <span className="product-name">
                        <span>{Product.Name}</span>
                        <span className="show-for-small-only opened-icon">
                            {this.state.openedOnSmall ? "-" : "+"}
                        </span>
                    </span>
                    <br />
                    <span className="created-date">
                        Created: <DateDisplay value={Product.CreatedDate} format="0D-0M-YYYY" />
                    </span>
                </Row>
                <Row className={"details-container" + (this.state.openedOnSmall ? " opened" : "")}>
                    <Column medium={10}>
                        {isWindow && <WindowSummaryItem Product={Product} />}
                        {isDoor && isUPVC && <DoorUPVCSummaryItem Product={Product} />}
                        {isDoor && isComposite && <DoorCompositeSummaryItem Product={Product} />}
                        {isConservatory && <ConservatorySummaryItem Product={Product} />}
                        {isAdditional && <AdditionalSummaryItem Product={Product} />}
                    </Column>
                    <Column medium={2} className="quantity-col">
                        <Row>
                            <Column small={2} medium={12} className="quantity-label">
                                Quantity
                            </Column>
                            <Column small={5} medium={12} className="quantity-container">
                                <input type="number" value={Product.Quantity} onChange={onChange} />
                            </Column>
                            <Column small={5} medium={12} className="remove-container">
                                <span className="remove-wrapper">
                                    <span className="remove-button" onClick={onDelete}>
                                        <img src={removeIcon} alt="Remove Item" />
                                    </span>
                                    <p>Remove</p>
                                </span>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        );
    }
}

export default SummaryItem;



// WEBPACK FOOTER //
// ./src/components/SummaryItem.js